// The teams section of "Omat tiedot": tells a team manager that they are one, and takes them to
// their team's bookings. See kumpula/TEAMS.md.
//
// Kept as its own component so the profile screen carries one import and one line of it.
//
// Two things it deliberately does NOT do:
//  - fire a callable for everyone. The profile page is opened by ordinary customers who have
//    nothing to do with a league, so it asks only on venues where the feature is switched on.
//  - occupy space while it does not apply. A customer who manages no team sees nothing at all -
//    no heading, no empty state - so the section simply is not there for them.
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Button, CardSubtitle, CardText } from 'reactstrap'
import Divider from '@material-ui/core/Divider'
import { useManagerTeams } from '../../utils/useManagerTeams'
import { describeFormat } from '../../utils/teamformats'

function TeamsProfileSection({ appconfig }) {
  const { t } = useTranslation()
  const history = useHistory()
  const enabled = !!(appconfig && appconfig.teams)
  // The hook is called unconditionally - rules of hooks - but does nothing without an account,
  // and the section renders nothing unless the venue has the feature on.
  const { loading, data } = useManagerTeams({ appconfig: enabled ? appconfig : null })

  if (!enabled || loading) return null

  const teams = (data && data.teams) || []
  if (!teams.length) return null

  const seasons = (data && data.seasons) || []
  const formats = (data && data.formats) || []
  const quota = (data && data.quota) || {}

  return (
    <>
      <CardSubtitle tag='h6' className='mb-2 mt-2 text-muted'>
        {t('teams_title')}
      </CardSubtitle>
      <CardText>{t('teams_profile_is_manager')}</CardText>
      {teams.map((team) => {
        const season = seasons.find((s) => s.id === team.seasonid)
        const format = formats.find((f) => f.id === team.formatid)
        const own = quota[team.id]
        return (
          <CardText key={team.id}>
            <strong>{team.name}</strong>
            {season ? ' - ' + season.name : ''}
            <br />
            <span className='text-muted small'>
              {describeFormat(format)}
              {own ? ' - ' + t('teams_quota') + ': ' + own.used + ' / ' + own.quota : ''}
            </span>
          </CardText>
        )
      })}
      <Button
        color='secondary'
        size='sm'
        onClick={() => history.push(appconfig.pathPrefix + '/teams')}
      >
        {t('teams_profile_link')}
      </Button>
      <Divider style={{ marginTop: 10 }} />
    </>
  )
}

export default TeamsProfileSection
